import { render, staticRenderFns } from "./TColumn.vue?vue&type=template&id=058d815c&"
import script from "./TColumn.vue?vue&type=script&lang=js&"
export * from "./TColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports